import { download } from "server/download";
import { settings, errorMessages } from "app";
import { documentRequests } from "api/documentsApi";

// Backend 400 rejects carry an errorCode → show the mapped BG message; non-400 errors throw a
// technical Error without an errorCode, so fall back to a contextual message. Exported for callers
// that need the failure themselves (e.g. a modal that must stay open) and so call `download` directly.
export const documentErrorMessage = e =>
  errorMessages[e?.errorCode ?? e?.ErrorCode] || "Възникна грешка в генерирането на документ!";

export const getFile = (fileId, notify, documentType = "dynamic", shouldDownload = false) => {
  const url = `${settings.gatewayApi}/${documentRequests.getDocumentById(fileId, documentType)}`;
  download(url, `file${fileId}`, "GET", null, shouldDownload)
    .then(res => {
      // notify("Успешно генерирахте документ!", { type: "success" });
    })
    .catch(e => {
      notify(documentErrorMessage(e), { type: "error" });
    });
};

// Downloads a file from a given URL. Pass method/data to POST a JSON body (e.g. user-typed document macros).
export const getFileFromUrl = (url, fileName, notify, method = "GET", data = null) => {
  return download(url, fileName, method, data, true)
    .then(res => {
      // notify("Успешно генерирахте документ!", { type: "success" });
    })
    .catch(e => {
      notify(documentErrorMessage(e), { type: "error" });
    });
};

// Previews a file from a given URL without downloading it. Same optional method/data as getFileFromUrl.
export const previewFileFromUrl = (url, fileName, notify, method = "GET", data = null) => {
  return download(url, fileName, method, data, false)
    .then()
    .catch(e => {
      notify(documentErrorMessage(e), { type: "error" });
    });
};
